 <div *ngIf="!showResetPassScreen"> 
<div *ngIf="checkClientSelectionPage" class="set-width">
    <div class="center-align"> 
        <div class="display-45"> 
    <div class="header-class">
        <div>
            
            <img class="mr-4" style="width: 35px;" src="../../../assets/Logos/user.png" />
            {{'FirstLogin_Label_001' | translate}}
        </div>
        <div class="language-change" id="languageDropdown" (click)="changeLanguage()">
            {{ defaultLanguage === 'NL'? 'FR': 'NL' }}
        </div>
    </div>

    <form [formGroup]="FormEmailPwdChange" (ngSubmit)="ValidateAndSave()">
        <div class="card-body">
            <div class="px-3" *ngIf="role_CO_x">  
               <b> {{'FirstLogin_CO_x' |translate}}</b>
                
            </div>
            <div class="px-3" *ngIf="role_AF_x">
                <b>   {{'FirstLogin_AF_x' | translate}}</b>
            </div>

            <div class="px-3" *ngIf="role_SS_x">
                <b>   {{'FirstLogin_SS_x' | translate}}</b>
            </div>
            <div class="d-flex my-3">
                <div class="col-md-4">{{'first_login_OD0012' | translate}}</div>
                <div class="col-md-8">{{fetchedUserName}}</div>
            </div>

            <div class="d-flex mb-3">
                <div class="col-md-4">{{'first_login_OD0013' | translate}}</div>
                <div class="col-md-8">{{fetchedEmail}}</div>
            </div>

            <div class="d-flex mb-3">
                <div class="col-md-4">{{'first_login_OD0014' | translate}}</div>
                <div class="col-md-8">
                    <input type="email" formControlName="emailAddress"  style="width: 100%;"
                        placeholder="example@mail.com">
                    <div class="error-message" *ngIf="IsEmailPatternUnmatched">
                        {{'email_wrong_OD0188' | translate}}
                    </div>
                    <div class="error-message" *ngIf="isEmailMadetory">
                        {{'Change_email_OD0205' | translate}}
                    </div>
                </div>

            </div>

            <div class="d-flex mb-3">
                <div class="col-md-4">{{'first_login_OD0015' | translate}}</div>
                <div class="col-md-8">
                    <input type="email" formControlName="emailAddressConfirmed" style="width: 100%;" placeholder="-">
                    <div class="error-message" *ngIf="emailMustMatch">
                        {{'confirm_new_email_diferent_OD0190' | translate}}</div>
                        <div class="error-message" *ngIf="isConfirmEmailMadetory">
                            {{'Change_email_OD0205' | translate}}</div>

                </div>
            </div>
            <div class="px-3" *ngIf="role_CO_y">
             <b>   {{'FirstLogin_CO_SS_y' |translate}} </b>
                
            </div>
            <div class="px-3" *ngIf="role_SS_y">
                
                <b>   {{'FirstLogin_CO_SS_y' |translate}}</b>
                
            </div>
            <div class="px-3" *ngIf="role_AF_y">
                
                <b>   {{'FirstLogin_AF_y' |translate}}</b>
                
            </div>

           

             <div class="error-message" *ngIf="msgErrorEmail"> {{'ChangeEmail_error_OD0189'  | translate}}</div>
            <div class="px-3" style=" margin-top:10px ; " *ngIf="mailSentFlg">
                
                <b>   {{'FirstLogin_mailSentLable_001'|translate}}</b>
                
            </div>
            
        </div>
        <div class="footer-class">
            <button type="submit" class="btn btn-orange" [disabled]="mailSentFlg">
                <img class="mr-2" src="../../../../../assets/Logos/checkmark-white.svg">
                {{'first_login_OD0021' | translate}}
            </button>
        </div>
    </form>
    </div>
    </div>

</div>
</div>
<div *ngIf="!checkClientSelectionPage">
    <div>
        <app-client-selection [clients]=clients></app-client-selection>
    </div>
</div>

<div *ngIf="showResetPassScreen">

    <div>
        <app-first-login-passwordreset></app-first-login-passwordreset>
    </div>

</div>